// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gradient-block{position:absolute;z-index:1;left:0;right:0;bottom:0;height:70px;background:var(--15b0h9d)}.product-typography-text{margin-bottom:32px}.product-typography-text__wrapper{position:relative;overflow:hidden;transition:max-height .7s ease-in-out}", ""]);
// Exports
module.exports = exports;
